import { render, staticRenderFns } from "./BloqueSlider.vue?vue&type=template&id=3787af55&scoped=true"
import script from "./BloqueSlider.vue?vue&type=script&lang=js"
export * from "./BloqueSlider.vue?vue&type=script&lang=js"
import style0 from "./BloqueSlider.vue?vue&type=style&index=0&id=3787af55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3787af55",
  null
  
)

export default component.exports